import FlickityCarousel from "./flickityCarousel";
new FlickityCarousel();